<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  console.log(listData)
  const time = ['1月', '2月', '3月', '4月', '5月', '6月']
  const data = [
    { name: '用电量', data: [100, 200, 300, 400, 500, 600] },
    { name: '用水量', data: [200, 300, 400, 300, 200, 500] },
  ]

  const option= {
    color: ['#FFE400', '#00FFDE'],
    tooltip: {
      trigger: 'axis',
      borderWidth: 0,
      backgroundColor: 'rgba(1, 65, 122,0.5)',
      textStyle: { // 添加 textStyle 属性
        color: '#fff' // 设置字体颜色
      },
      // valueFormatter: (params) => {
      //    return params + 'kg'
      // }
      formatter: function (params) {
        const time = params[0].name || ''
        const before = params[0] || ''
        const after = params[1] || ''
        // 使用CSS样式来设置marker的形状为方形
        const beforeMarkerStyle = 'display: inline-block; width: 5px; height: 14px; margin-right:3px; background-color: ' + before.color + ';';
        const afterMarkerStyle = 'display: inline-block; width: 5px; height: 14px; margin-right:3px; background-color: ' + after.color + ';';
        const beforeContent = before ? `${'<span style="' + beforeMarkerStyle + '"></span>'} 前纺: ${before.value ?? ''} kg <br />` : ''
        const afterContent = after ? `${'<span style="' + afterMarkerStyle + '"></span>'} 后纺: ${after.value ?? ''} kg <br />` : ''
        return `${time}<br/>${beforeContent}${afterContent}`
      },
    },
    legend: {
      icon: 'stack',
      itemWidth: 14,
      itemHeight: 9,
      top:"3%",
      textStyle: {
        fontSize: 14,
        color: '#e0e1e2', // 设置字体颜色
        padding: [10, 10] // 设置文字与图例的距离
      },
      itemGap: 20,// 设置图例项之间的间距
      itemStyle: {
        borderWidth: 0
      }
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: '10%',
      top: '15%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,//两侧留白
      axisLine: {
        lineStyle: {
          color: 'rgba(2, 119, 175,.5)',
          width: 2,
          type: 'solid',
        },
        show: true,
        onZero: false // 将 x 轴坐标轴置于最低刻度上
      },
      axisLabel: {
        interval: 0,
        color: 'rgba(255,255,255)', //更改坐标轴文字颜色
        fontSize: 12, //更改坐标轴文字大小
        margin: 20
      },
      axisTick: {
        show: false,
        alignWithLabel: true,
        lineStyle: {
          color: 'rgba(2, 119, 175)', // 刻度线颜色
          width: 2, // 刻度线宽度
        },
        length: 6, // 刻度线的长度
      },
      data: time,
    },
    yAxis: [
      {
        // name: '温度',
        type: 'value',
        min: "0",
        // max: 100,
        splitNumber: 3,
        splitLine: {
          interval: 0,
          show: true, // 开启分割线
          lineStyle: {
            color: 'rgba(6, 88, 142,.8)',
            width: 1,
            type: [6, 3],
          },
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          color: 'rgba(207, 219, 230)'
        },
        position: 'left',
      }
    ],
    series: [{
      name: '用电量',
      type: 'line',
      symbol: 'circle',
      emphasis: {
        focus: 'series',//高亮显示
      },
      symbolSize: 6,
      data: data[0].data,
      smooth: false,//曲线
      itemStyle: {
        // 折线拐点标志的样式
        borderColor: '#FFE400',
        borderWidth: 2
      },
      // z: 2,
      areaStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "rgba(255, 228, 0,0.5)"
              },
              {
                offset: 0.5,
                color: "rgba(255, 228, 0,0.3)"
              },
              {
                offset: 1,
                color: "rgba(255, 228, 0,0)"
              }
            ],
          )
        }
      }
    },
      {
        name: '用水量',
        type: 'line',
        symbol: 'circle',
        symbolSize: 6,
        data: data[1].data,
        smooth: false,//曲线
        itemStyle: {
          //折线拐点标志的样式
          borderColor: '#00FFDE',
          borderWidth: 2
        },
        emphasis: {
          focus: 'series',//高亮显示
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(41, 122, 129,0.5)"
                },
                {
                  offset: 0.5,
                  color: "rgba(23, 97, 127,0.3)"
                },
                {
                  offset: 1,
                  color: "rgba(2, 71, 135)"
                }
              ],
            )
          }
        }
      },

    ]
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
